import React from 'react';
import {
	List,
	Datagrid,
	TextField,
	DateField,
	ReferenceField,
	ReferenceInput,
	SelectInput,
	AutocompleteInput,
	Edit,
	Create,
	SimpleForm,
	TextInput,
	Filter,
	required,
} from 'react-admin';

const statusChoices = [
	{ id: 'submitted', name: 'Soumise' },
	{ id: 'qualified', name: 'Qualifiée' },
	{ id: 'signed', name: 'Signée' },
	{ id: 'lost', name: 'Perdue' },
];

const OpportunityFilter: React.FC = (props: any) => (
	<Filter {...props}>
		<ReferenceInput source="partner_id" reference="partners" label="Partenaire" alwaysOn>
			<AutocompleteInput optionText="name" />
		</ReferenceInput>
		<SelectInput source="status" choices={statusChoices} alwaysOn />
	</Filter>
);

// #region OpportunityList
export const OpportunityList: React.FC = (props: any) => (
	<List {...props} filters={<OpportunityFilter />} sort={{ field: 'created_at', order: 'DESC' }}>
		<Datagrid rowClick="edit">
			<ReferenceField source="partnerId" reference="partners" label="Partenaire" link={false}>
				<TextField source="name" />
			</ReferenceField>
			<TextField source="companyName" label="Société" />
			<TextField source="contactEmail" label="Contact" />
			<TextField source="status" label="Statut" />
			<ReferenceField source="planId" reference="plans" label="Abonnement" link={false}>
				<TextField source="name" />
			</ReferenceField>
			<DateField source="createdAt" label="Soumise le" />
		</Datagrid>
	</List>
);
// #endregion

// #region OpportunityEdit
export const OpportunityEdit: React.FC = (props: any) => (
	<Edit {...props}>
		<SimpleForm>
			<TextInput source="companyName" label="Société" validate={required()} />
			<TextInput source="contactName" label="Nom du contact" />
			<TextInput source="contactEmail" label="Email du contact" validate={required()} />
			<TextInput source="contactPhone" label="Téléphone" />
			<SelectInput source="status" label="Statut" choices={statusChoices} />
			<ReferenceInput source="planId" reference="plans" label="Type d'abonnement">
				<SelectInput optionText="name" />
			</ReferenceInput>
			<TextInput source="notes" label="Notes" multiline fullWidth />
		</SimpleForm>
	</Edit>
);
// #endregion

// #region OpportunityCreate
export const OpportunityCreate: React.FC = (props: any) => (
	<Create {...props}>
		<SimpleForm>
			<ReferenceInput source="partnerId" reference="partners" label="Partenaire">
				<AutocompleteInput optionText="name" validate={required()} />
			</ReferenceInput>
			<TextInput source="companyName" label="Société" validate={required()} />
			<TextInput source="contactName" label="Nom du contact" />
			<TextInput source="contactEmail" label="Email du contact" validate={required()} />
			<TextInput source="contactPhone" label="Téléphone" />
			<ReferenceInput source="planId" reference="plans" label="Type d'abonnement">
				<SelectInput optionText="name" />
			</ReferenceInput>
			<TextInput source="notes" label="Notes" multiline fullWidth />
		</SimpleForm>
	</Create>
);
// #endregion
